import { useEffect, useState } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import styled from "styled-components";
import "./App.css";
import {
  Category,
  CreateAccount,
  Header,
  Login,
  PaymentMethod,
  RightSidebar,
} from "./components";
import Address from "./components/Address";
import CheckoutSuccess from "./components/CheckoutSuccess";
import DescriptionAlerts from "./subComponent/DescriptionAlerts";
import ItemDetails from "./components/ItemDetails";
import Orders from "./components/Orders";
import SearchPage from "./components/SearchPage";
import { useStateContext } from "./contexts/ContextProvider";
import GlobalStyle from "./globalStyle";
import { Home } from "./pages";
import Cart from "./pages/Cart";
import NotFound from "./subComponent/NotFound";
const App = () => {
  const {
    isScrolled,
    sidebarOpened,
    setSidebarOpened,
    alert,
    setAlert,
    showSearch,
    setShowSearch,
    setInputHover,
  } = useStateContext();

  useEffect(() => {
    setAlert(false);
  }, []);

  return (
    <>
      <GlobalStyle sidebarOpened={sidebarOpened} />
      <Container className="App ">
        <BrowserRouter>
          <div style={{ marginRight: "0vw" }}>
            <div
              className="header_background"
              style={{
                position: "fixed",
                top: "0",
                width: "100vw",
                zIndex: 1100,
                background: `${isScrolled ? "rgba(255,255,255,0.5)" : ""}`,
                backdropFilter: `${isScrolled ? "blur(10px)" : "blur(0px)"}`,
                boxShadow: `${
                  isScrolled ? "0px 4px 7px 0px rgba(0,0,0,0.2)" : ""
                }`,
                height: "10vh",
                transition:
                  "background 0.3s ease-out, box-shadow 0.3s ease-out",
              }}
            >
              <Header />
            </div>
            <div
              className="header_background"
              style={{
                position: "fixed",
                top: "10px",
                right: "10px",
                width: "70vw",
                zIndex: 1110,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            >
              {alert ? <DescriptionAlerts /> : ""}
            </div>

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/category/:id" element={<Category />} />
              <Route
                path="/itemdetails/:id/:categ_id"
                element={<ItemDetails />}
              />
              <Route path="/searchpage/:id" element={<SearchPage />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<CreateAccount />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/address" element={<Address />} />
              <Route path="/checkout-success" element={<CheckoutSuccess />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>

          <div
            style={{
              position: "fixed",
              top: "0",
              width: `${showSearch ? "100vw" : 0} `,
              transition: "all 0.1s",
              zIndex: "1099",
              height: "100vh",
              right: "0",
              background: "rgba(0, 0, 0, 0.7)",
            }}
            onClick={() => {
              setShowSearch(false);
              setInputHover(false);
            }}
          >
            {" "}
          </div>
          <div
            style={{
              position: "fixed",
              top: "0",
              width: `${sidebarOpened ? "100vw" : 0} `,
              transition: "all 0.1s",
              zIndex: "1200",
              right: "0",
              background: "rgba(0, 0, 0, 0.7)",
            }}
          >
            <div
              style={{
                color: "white",
                position: "absolute",
                zIndex: "1200",
                right: "31%",
                top: "7px",

                cursor: "pointer",
                fontSize: `${sidebarOpened ? "30px" : 0}`,
              }}
              className="cancel"
            >
              {" "}
              <MdOutlineCancel
                onClick={() => setSidebarOpened(!sidebarOpened)}
              />
            </div>
            <RightSidebar />
          </div>
        </BrowserRouter>
      </Container>
    </>
  );
};

export default App;

const Container = styled.div`
  .cancel {
    @media (max-width: 440px) {
      right: 70% !important;
    }
  }
`;